import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchAllData } from '../services/api';

const DataContext = createContext();

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export const DataProvider = ({ children }) => {
  const [data, setData] = useState({
    abouts: [],
    skills: [],
    experiences: [],
    works: [],
    achievements: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const allData = await fetchAllData();
        setData(allData);
        
      } catch (err) {
        setError(err.message);
        console.error('Failed to load data:', err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  const value = {
    data,
    loading,
    error,
    // Convenience getters for each data type
    abouts: data.abouts,
    skills: data.skills,
    experiences: data.experiences,
    works: data.works,
    achievements: data.achievements
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
}; 